import { IInitialState } from 'store/models';
import { respondentDataSelector } from './respondentDataSelector';

export function respondentIdSelector(state: IInitialState) {
	return respondentDataSelector(state)?.id;
}
